// extracted by mini-css-extract-plugin
module.exports = {"Container":"Complaint_Container__1UV_t","form":"Complaint_form__2z3zJ","Submit":"Complaint_Submit__3H4d3","Error":"Complaint_Error__2Z8Bf"};